// Bu fonksiyon, tarayıcıdan sunucuya log göndermek için kullanılır.

const sendLog = (level, message, data = null) => {
    // Geliştirme ortamında konsola da yazdır, hata ayıklamayı kolaylaştırır.
    if (process.env.NODE_ENV === 'development') {
        if (level === 'error') {
            console.error(`[WebLogger] ${message}`, data);
        } else {
            console.log(`[WebLogger] ${message}`, data);
        }
    }

    // Sunucuya gönderme isteği. 'keepalive: true' sayfa kapansa bile isteğin gitmesini sağlar.
    fetch('/api/log', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ level, message, data }),
        keepalive: true, 
    }).catch(error => {
        // Log gönderme işlemi başarısız olursa, bunu sadece tarayıcı konsoluna yaz.
        console.error('Sunucuya log gönderilemedi:', error);
    });
};

export const webLogger = {
    log: (message, data) => sendLog('info', message, data),
    error: (message, data) => sendLog('error', message, data),
};